import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { getDocInfo, getDocsForOrg, getDocsForStage, getDocsForStageOrg } from '../../../dict/DOCS'
import { Li } from '.'
import RootStoreContext from '../../../storage/RootStore'
import { When } from 'react-if'

/// functions
/// types
/// components

interface DocumentsProps {
    forOrg?: string
    forStage?: string
}

export const Documents: React.FC<DocumentsProps> = observer(({
    forOrg: orgID,
    forStage: stageID
}) => {

    const { selection } = useContext(RootStoreContext)


    if (!orgID && !stageID) {
        return null
    }


    if (orgID && stageID) {
        return (
            <>
                <p><b>Документи, пов'язані з організацією на даному етапі</b></p>

                <ul>
                    {getDocsForStageOrg(stageID, orgID).length ? getDocsForStageOrg(stageID, orgID).map(docID => {



                        let { fullname, subject } = getDocInfo(docID)

                        const id = `doc-${docID}-connected`

                        const onClick = () => {
                            selection.setDoc(docID)
                            selection.setView('documents')
                        }

                        if (true){
                            return (
                                <Li key={id} id={id} onClick={onClick}>
                                    {fullname}
                                </Li>
                            )
                        }

                        return null

                    }) : null}
                </ul>
            </>
        )
    } else {


        if (orgID) {
            return (
                <When condition={getDocsForOrg(orgID).length}>
                    <p><b>Документи пов'язані з організацією</b></p>

                    <ul>
                        {getDocsForOrg(orgID).map(docID => {
                            let { fullname } = getDocInfo(docID)
                            const id = `document-${docID}-connected`

                            const onClick = () => {
                                selection.setDoc(docID)
                                selection.setView('documents')
                            }

                            return (
                                <Li key={id} id={id} onClick={onClick}>
                                    {fullname}
                                </Li>
                            )
                        })}
                    </ul>
                </When>
            )
        }


        if (stageID) {
            return (
                <When condition={getDocsForStage(stageID).length}>
            
                    <p><b>Документи пов'язані з цим етапом:</b></p>
                    <ul>
                        {getDocsForStage(stageID).map(docID => {
                            let { fullname } = getDocInfo(docID)

                            const id = `doc-${docID}-connected`

                            const onClick = () => {
                                selection.setDoc(docID)
                                selection.setView('documents')
                            }

                            return (
                                <Li key={id} id={id} onClick={onClick}>
                                    {fullname}
                                </Li>
                            )
                        })}
                    </ul>
                </When>
            )
        }
    }

    return null
})
